module.exports = __webpack_public_path__ + "img/PXioNf1l-EmRPaQ,Scan0005.5f7a1bcd.jpeg";